import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.splice.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
export var Event = /*#__PURE__*/function () {
  function Event() {
    _classCallCheck(this, Event);

    this.queue = {};
  }

  _createClass(Event, [{
    key: "on",
    value: function on(type, listener) {
      if (typeof listener !== 'function') {
        return;
      }

      if (!this.queue[type]) {
        this.queue[type] = [];
      }

      this.queue[type].push(listener);
    }
  }, {
    key: "trigger",
    value: function trigger(type) {
      var i;

      if (!this.queue[type]) {
        return;
      }

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      for (i = 0; i < this.queue[type].length; i++) {
        this.queue[type][i].apply(this, args);
      }
    }
  }, {
    key: "off",
    value: function off(type, listener) {
      var listeners = this.queue[type];
      if (!listeners) return;

      if (!listener) {
        delete this.queue[type];
      }

      var idx = listeners.indexOf(listener);
      listeners.splice(idx, 1);
    }
  }, {
    key: "once",
    value: function once(type, listener) {
      var _this = this;

      var cbFn = function cbFn() {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        listener.apply(_this, args);

        _this.off(type, cbFn);
      };

      this.on(type, cbFn);
    }
  }]);

  return Event;
}();
var event = new Event();
event.Event = Event;
export default event;